// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".consent-app-frame{margin:0}.consent-app-frame__back-button{padding-left:16px}.consent-app-frame__iframe-wrapper{-webkit-overflow-scrolling:touch;overflow-y:auto}", ""]);
// Exports
module.exports = exports;
